<template>
  <div class="checkbox-button">
    <div
      class="checkbox-button__container"
      @click="$emit('change', !checked)">
      <w-checkbox
        class="checkbox-button__checkbox"
        :checked="checked"
        @change="$emit('change', $event)"/>
    </div>
    <div class="checkbox-button__content">
      <slot/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WCheckboxButton',
    model: {
      prop: 'checked',
      event: 'change',
    },
    props: {
      checked: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../assets/styles/variables";

  .checkbox-button {
    display: flex;
    border-radius: 28px;
    height: 56px;
    overflow: hidden;
    font-family: 'Roboto';
    font-size: 14px;

    @include shadow-5;

    .checkbox-button__container {
      position: relative;
      width: 60px;
      height: 100%;
      background-color: $secondary-light;
      cursor: pointer;
      box-sizing: border-box;

      .checkbox-button__checkbox {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .checkbox-button__content {
      background-color: $background-4;
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 16px;
      font-size: 14px;
      height: 100%;
      box-sizing: border-box;

      & > * {
        &:first-child {
          margin-right: 2px;
        }

        &:not(:first-child) {
          margin-left: 2px;
        }
      }
    }
  }
  #terms {
    .checkbox-button__content {
      @media (max-width: 776px) {
        flex-direction: column;
        align-items: flex-start;
        .terms {
          margin-left: 0;
        }
      }
    }
  }
</style>
